/** NAATI-style mock grading criteria (keys match backend MockTestGrade fields). */
export const MOCK_GRADING_CRITERIA = [
  { key: 'distortion', label: 'Distortion' },
  { key: 'unjustified_omission', label: 'Unjustified omission' },
  { key: 'unjustified_insertion', label: 'Unjustified insertion' },
  { key: 'inappropriate_register', label: 'Inappropriate register' },
  { key: 'unidiomatic_expression', label: 'Unidiomatic expression' },
  { key: 'grammar_syntax_error', label: 'Error of grammar and syntax' },
  { key: 'spelling_error', label: 'Error of spelling' },
  { key: 'punctuation_error', label: 'Error of punctuation' },
] as const;

export type MockGradingCriterionKey = (typeof MOCK_GRADING_CRITERIA)[number]['key'];
